<template>
    <modal ref="modal">
        <form @submit="submit">
            <div class="title">{{ $t('modals.contact.title') }}</div>
            <div>
                <label>{{ $t('labels.message') }} *</label>
                <textarea ref="message" v-model="message" :class="error ? 'error' : ''"/>
                <div class="error" v-if="error">{{ error }}</div>
            </div>
            <button>{{ $t('modals.contact.button') }}</button>
        </form>
    </modal>
</template>

<script>
import user from '@/services/user'

export default {
  data () {
    return {
      error: '',
      message: ''
    }
  },
  methods: {
    show () {
      this.error = ''
      this.message = ''
      this.$refs.modal.show()
      this.$nextTick(function () {
        this.$refs.message.focus()
      }.bind(this))
    },
    hide () {
      this.$refs.modal.hide()
    },
    submit (e) {
      // Init
      e.preventDefault()
      this.error = ''

      // Check message
      if (!this.message || this.message === '') {
        // Update error
        this.error = this.$i18n.t('mandatory.message')
        return
      }

      // Contact
      user.contact(this.message)
        .then((message) => {
          // Hide
          this.hide()

          // Toast
          this.$parent.$parent.$parent.$parent.$refs.toaster.success(message)
        })
        .catch(err => {
          // Update error
          this.error = err
        })
    }
  }
}
</script>

<style scoped>

textarea {
  height: 20em;
  width: 30em;
}

</style>
